<template>
  <div>
    <apexchart
      v-if="hasDates && dayCategories.length"
      type="bar"
      height="460"
      :options="daysOpts"
      :series="daysSeries"
    />
    <empty-state
      v-else
      icon="mdi-calendar-range"
      :title="$t('no_data')"
      :subtitle="$t('select_wider_date_range')"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import EmptyState from "@/components/global/EmptyState.vue";
import { SHIFT_COLORS, CHART_FONT, GRID_COLOR } from "@/components/statistics-report/statsTheme";

export default {
  name: "GroupMealsDaysChart",
  components: { apexchart: VueApexCharts, EmptyState },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    shiftLabels() {
      return [
        this.$t("1st_shift"),
        this.$t("2nd_shift"),
        this.$t("3rd_shift"),
        this.$t("4th_shift"),
      ];
    },
    hasDates() {
      return this.orders.some((item) => !!item.date);
    },
    dayAgg() {
      const map = {};
      for (const item of this.orders) {
        if (!item.date) continue;
        if (!map[item.date]) map[item.date] = [0, 0, 0, 0];
        if (item.shift_1 !== undefined) {
          map[item.date][0] += Number(item.shift_1 || 0);
          map[item.date][1] += Number(item.shift_2 || 0);
          map[item.date][2] += Number(item.shift_3 || 0);
          map[item.date][3] += Number(item.shift_4 || 0);
        } else {
          const s = (item.shift || 1) - 1;
          if (s >= 0 && s < 4) map[item.date][s] += Number(item.quantity || 0);
        }
      }
      return map;
    },
    dayCategories() {
      return Object.keys(this.dayAgg).sort();
    },
    daysSeries() {
      return this.shiftLabels.map((label, i) => ({
        name: label,
        data: this.dayCategories.map((d) => this.dayAgg[d]?.[i] || 0),
      }));
    },
    daysOpts() {
      return {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: { show: true },
          zoom: { enabled: true },
          fontFamily: CHART_FONT,
        },
        plotOptions: { bar: { horizontal: false, borderRadius: 3, columnWidth: "60%" } },
        colors: SHIFT_COLORS,
        xaxis: {
          categories: this.dayCategories,
          labels: { style: { fontSize: "11px" } },
        },
        legend: { position: "bottom" },
        dataLabels: { enabled: false },
        tooltip: { shared: true, intersect: false },
        fill: { opacity: 1 },
        grid: { borderColor: GRID_COLOR },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: { height: 360 },
              xaxis: { labels: { style: { fontSize: "10px" } } },
              legend: { fontSize: "12px" },
            },
          },
        ],
      };
    },
  },
};
</script>
